import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.starts-with.js";
import { isString } from 'lodash-es';
import { HttpStatusCode } from '~/core/enums';
import { ReservedQueryKey } from '~/core/enums/routing';
import { buildNextQuery, isTrustedUrl } from '~/core/functions/url';
import { AuthErrorDataCode } from '~/features/Authorization/enums';
var resolveInternalNext = function resolveInternalNext(to) {
  var requestedNext = to.query.next;
  return isString(requestedNext) && requestedNext.startsWith('/') ? requestedNext : '/';
};
export var resolveMasterPasswordForbidden = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, response) {
    var _response$data;
    var _useNuxtApp, $featureFlag, errorCode, preselectedCountry, _next, _nextQuery, next, nextQuery;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _useNuxtApp = useNuxtApp(), $featureFlag = _useNuxtApp.$featureFlag;
          if (!(!$featureFlag('wff_master_password') || (response === null || response === void 0 ? void 0 : response.status) !== HttpStatusCode.Forbidden)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", null);
        case 3:
          errorCode = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code;
          preselectedCountry = to.query[ReservedQueryKey.PreselectedCountry]; // NOTE: Для авторизации на других продуктах МедРокет не нужно вводить мастер-пароль, редиректим на next
          _context.t0 = to.name === 'authorization' && errorCode === AuthErrorDataCode.MasterPasswordRequired && isString(to.query.next);
          if (!_context.t0) {
            _context.next = 10;
            break;
          }
          _context.next = 9;
          return isTrustedUrl(to.query.next);
        case 9:
          _context.t0 = _context.sent;
        case 10:
          if (!_context.t0) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", {
            path: to.query.next,
            external: true,
            replace: true
          });
        case 12:
          if (!(errorCode === AuthErrorDataCode.MasterPasswordRequired)) {
            _context.next = 18;
            break;
          }
          if (!(to.name === 'master-password')) {
            _context.next = 15;
            break;
          }
          return _context.abrupt("return", {
            path: to.fullPath
          });
        case 15:
          _next = to.name === 'authorization' ? resolveInternalNext(to) : to.fullPath;
          _nextQuery = buildNextQuery(_next, preselectedCountry);
          return _context.abrupt("return", {
            path: "/master-password/".concat(_nextQuery)
          });
        case 18:
          if (!(errorCode !== AuthErrorDataCode.MasterPasswordAttemptsExceeded)) {
            _context.next = 20;
            break;
          }
          return _context.abrupt("return", null);
        case 20:
          if (!(to.name === 'master-password' && to.query[ReservedQueryKey.MasterPasswordAttemptsExceeded])) {
            _context.next = 22;
            break;
          }
          return _context.abrupt("return", {
            path: to.fullPath
          });
        case 22:
          next = to.name === 'authorization' || to.name === 'master-password' ? resolveInternalNext(to) : to.fullPath;
          nextQuery = buildNextQuery(next, preselectedCountry);
          return _context.abrupt("return", {
            path: "/master-password/".concat(nextQuery, "&").concat(ReservedQueryKey.MasterPasswordAttemptsExceeded, "=true"),
            replace: to.name === 'master-password'
          });
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function resolveMasterPasswordForbidden(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();